import { Injectable } from '@angular/core';
import { NbComponentStatus, NbToastrService } from '@nebular/theme';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';

import {
  MESSAGE_TYPES,
  NOT_FOUND_MSG_TYPE,
  NOTIFICATION_MESSAGES,
  GLOBAL_MESSAGE_TYPE_LIST_MAP,
  ERROR_CONTENT_TYPE
} from './config';

@Injectable()
export class MessageService {
  smthWentWrongMsg = '';
  notificationMessages = {};

  constructor(
    private translateService: TranslateService,
    private toastrService: NbToastrService
  ) {
    if (!this.smthWentWrongMsg) {
      this.translateService.get(NOTIFICATION_MESSAGES).subscribe(
        notificationMessages => {
          this.notificationMessages = notificationMessages;
          this.smthWentWrongMsg = notificationMessages[NOT_FOUND_MSG_TYPE];
        });
    }
  }

  setGlobalError(error: any): void {
    let globalErrorMessage: any = {};
    let globalErrorType = '';

    [globalErrorMessage, globalErrorType]
      = this.parseError(error, true);

    globalErrorType = GLOBAL_MESSAGE_TYPE_LIST_MAP[globalErrorType];

    this.showToast(globalErrorType, globalErrorMessage.title, globalErrorMessage.detail);
  }

  setGlobalMsg(status, title, detail): void {
    this.showToast(status, detail, title);
  }

  parseError(error: any, fetchRegularMsgData = false): string[] {
    let message: any;
    let type: string;

    if (error) {
      type = MESSAGE_TYPES.error;

      message = fetchRegularMsgData ? this.fetchMessageData(error) : this.fetchMessageTemplate(error);
    } else if (error instanceof ReferenceError) {
      type = MESSAGE_TYPES.error;
      message = fetchRegularMsgData ? this.fetchMessageData({}) : this.fetchMessageTemplate({});
    } else {
      type = MESSAGE_TYPES.info;
      message = error;
    }

    return [message, type];
  }

  private fetchMessageData(error: any): any {
    const message = {
      title: '',
      detail: ''
    };

    if (error.errorContentType === ERROR_CONTENT_TYPE) {
      message.title = error.title || '';
      message.detail = error.detail || '';
    } else {
      message.title = '';
      message.detail = this.smthWentWrongMsg;
    }

    return message;
  }

  private fetchMessageTemplate(error: any): string {
    let message = '';

    if (error.errorContentType === ERROR_CONTENT_TYPE) {
      return `<div class="error-title font-weight-bold">${error.title || ''}</div> <div>${error.detail || ''}</div>`;
    } else {
      message = `<div>${this.smthWentWrongMsg}</div>`;
    }

    return message;
  }

  private showToast(status: any, message = '', title = '') {
    this.toastrService.show(message, title, { status });
  }
}
